const enum DeliveryMethodType {
  deliverable_action_meet_at_door = 'deliverable_action_meet_at_door',
  deliverable_action_leave_at_door = 'deliverable_action_leave_at_door',
}

export default DeliveryMethodType;
